import { useEffect, useState, useMemo } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Avatar from "../Tools/Avatar";
import { Link } from "react-router-dom";
import { Chip, Tab, Tabs, Link as A, Button, Stack } from "@mui/material";
import HotIcon from '@mui/icons-material/Whatshot';
import CheckIcon from '@mui/icons-material/Check';
import UncheckIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Grid from "../Tools/Grid";
import useJsonStore from "../../services/Hooks/useJsonStore";
import moment from "moment/moment";
import { Add } from "@mui/icons-material";
import FiltersForm from "./Person/FiltersForm";

export default function Persons(){
    
    const headers = [
        {
            field: 'avatar',
            headerName: 'Fiche',
            width: 60,
            valueGetter: p => p.row.initials,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Link to={`/crm/persons/${p.id}`}>
                    <Avatar 
                        initials={p.row.initials} 
                        color={p.row.category?.color || 'grey'} 
                        size={36} 
                    />
                </Link>,
        },
        {
            field: 'firstName',
            headerName: 'Prénom',
            width: 100,
            valueGetter: p => p.row.firstName
        },
        {
            field: 'lastName',
            headerName: 'Nom',
            width: 150,
            valueGetter: p => p.row.lastName
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            valueGetter: p => p.row.email,
            renderCell: p => !p.row.isAutoGenerated &&
                <A href={`mailto:${p.row.email}`}>{p.row.email}</A>,
        },
        {
            field: 'phone',
            headerName: 'Téléphone',
            width: 160,
            valueGetter: p => p.row.phone,
            renderCell: p => !p.row.isAutoGenerated &&
                <A href={`tel:${p.row.phone}`}>{p.row.phone}</A>
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 150,
            valueGetter: p => p.row.category?.title
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 100,
            valueGetter: p => p.row.type?.title,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Chip label={p.row.type?.title} size='small'/>
        },
        {
            field: 'hot',
            headerName: 'Chaud',
            width: 60,
            type: 'boolean',
            valueGetter: p => p.row.hot,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <HotIcon color={p.row.hot ? 'warning' : 'disabled'} />
        },
        {
            field: 'hotAt',
            headerName: 'Chaud à',
            type: 'date',
            width: 70,
            valueGetter: p => moment(p.row.hotEvent?.at).toDate(),
            renderCell: p => !p.row.isAutoGenerated &&
            moment(p.row.hotEvent?.at).format('HH:mm'),
            tabs: ['hot']
        },
        {
            field: 'event',
            headerName: 'Événement',
            width: 250,
            valueGetter: p => p.row.hotEvent?.title,
            tabs: ['hot']
        },
        {
            field: 'courses',
            headerName: 'Formations',
            type: 'number',
            valueGetter: p => p.row.enrollmentsCount || 0,
            width: 100,
        },
        {
            field: 'revenue',
            headerName: 'CA €',
            type: 'number',
            width: 100,
            valueGetter: p => p.row.revenue || 0,
        },
        {
            field: 'completion',
            headerName: 'Complétion %',
            type: 'number',
            width: 120,
            valueGetter: p => p.row.completion || 0,
        },
        {
            field: 'dutyMet',
            headerName: 'Obligation',
            width: 90,
            type: 'boolean',
            valueGetter: p => p.row.dutyMet,
            renderCell: p => !p.rowNode.isAutoGenerated &&
               (p.row.dutyMet ? 
                    <CheckIcon color='primary' size='small'/> : 
                    <UncheckIcon color='error' size='small'/>)
        },
        {
            field: 'status',
            headerName: 'Statut',
            width: 100,
            valueGetter: p => p.row.status?.title,
        },
        {
            field: 'rpps',
            headerName: 'RPPS',
            width: 150,
            valueGetter: p => p.row.rpps
        },
        {
            field: 'siret',
            headerName: 'SIRET',
            width: 150,
            valueGetter: p => p.row.siret
        },
        {
            field: 'workforce',
            headerName: 'Effectif',
            type: 'number',
            width: 80,
            valueGetter: p => p.row.workforce
        },
        {
            field: 'origin',
            headerName: 'Provenance',
            width: 150,
            valueGetter: p => p.row.origin?.title,
        },
        {
            field: 'subscription',
            headerName: 'Abonnement',
            width: 120,
            valueGetter: p => p.row.subscription?.title,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Chip 
                    color={p.row.subscription?.id === 'none' ? 'default' : 'primary'} 
                    size='small' 
                    label={p.row.subscription?.title} 
                />
        },
        {
            field: 'lastActivity',
            headerName: 'Dernière activité',
            width: 90,
            type: 'date',
            valueGetter: p => p.row.lastActivity && moment(p.row.lastActivity).toDate(),
            renderCell: p => p.value ? moment(p.row.lastActivity).format('DD/MM/YYYY à HH:mm') : '',
        },
        {
            field: 'createdAt',
            headerName: 'Créé le',
            width: 90,
            type: 'date',
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated &&
                moment(p.row.createdAt).format('DD/MM/YYYY à HH:mm'),
        },
    ];

    const [persons, setPersons] = useState(null)
    const [tab, setTab] = useState('all')
    const [filters, setFilters] = useState(null)
    const store = useJsonStore();
    

    useEffect(() => {

        const f = store.get('personFilters') || null;

        setFilters(f)

        if(f){
            let query = new URLSearchParams(f).toString();

            API.get(`/crm/users?${query}`).then(r => setPersons(r.data))
        }


    }, [store])


    const rows = useMemo(() => {

        const match = p => ['all', p.type?.id].includes(tab)

        return persons ? persons.filter(p => match(p)) : null

    }, [persons, tab])


    const columns = headers.filter(h => !h.tabs || h.tabs.includes(tab))


    const handleFilters = f => {

        setPersons(null)
        setFilters(f)

        if(f){
            let query = new URLSearchParams(f).toString();
            API.get(`/crm/users?${query}`).then(r => setPersons(r.data))
        }
    }


    return <Layout tab='persons' menu='crm' title='Contacts'>

        <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap'>

            <Tabs value={tab} onChange={(e,v) => setTab(v)}>
                <Tab label="Tous" value="all" />
                <Tab label="Inscrits" value="prospect" />
                <Tab label="Gratuits" value="subscriber" />
                <Tab label="Clients" value="customer" />
            </Tabs>

            <Stack direction='row' spacing={2}>
                <Button startIcon={<SearchIcon />} onClick={() => setFilters(null)}>
                    Filtrer
                </Button>

                <Link to='/crm/persons/new/edit'>
                    <Button variant='contained' startIcon={<Add />}>Ajouter</Button>
                </Link>
            </Stack>

        </Stack>

        {filters ?
            <Grid 
                id='personsGrid'
                columns={columns}
                rows={rows}
                toolbar
                aggregate={{
                    revenue: 'sum', 
                    completion: 'avg', 
                    courses: 'sum'
                }}
            />
            :
            <FiltersForm 
                onSubmit={f => handleFilters(f)}
            />
        }

    </Layout>

}


